// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import styles from './styles.js';

import clear from '../../images/close.png';

class Input extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    label: PropTypes.string,
    onChange: PropTypes.func,
    inputType: PropTypes.string,
    maxLength: PropTypes.number,
    minLength: PropTypes.number,
    required: PropTypes.bool,
    invalidFeedback: PropTypes.string,
    width: PropTypes.number,
    placeholder: PropTypes.string,
    fixedWidth: PropTypes.bool,
    // A date field holds a Date, which is what react-datepicker's `selected`
    // needs and what its onChange hands back - so both shapes are valid here.
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    name: PropTypes.string.isRequired,
    style: PropTypes.string,
    labelStyle: PropTypes.string,
    multiline: PropTypes.bool,
    dateType: PropTypes.bool,
    autoComplete: PropTypes.string,
    resetButton: PropTypes.bool,
    onFocus: PropTypes.func,
    onClick: PropTypes.func,
    // Lets a caller act on Enter. A handheld barcode scanner in keyboard
    // mode types the code and then sends Enter, so a field meant to be
    // scanned into has to be able to see that key. keydown rather than
    // keypress: keypress is deprecated and not fired for every key.
    onKeyDown: PropTypes.func,
    autoFocus: PropTypes.bool,
  };

  static defaultProps = {
    classes: {},
    label: null,
    onChange: () => { },
    inputType: 'text',
    minLength: 2,
    maxLength: 50,
    required: false,
    invalidFeedback: 'Invalid',
    width: null,
    placeholder: null,
    value: '',
    fixedWidth: false,
    style: '',
    labelStyle: '',
    multiline: false,
    dateType: false,
    autoComplete: null,
    resetButton: false,
    onFocus: () => { },
    onClick: () => { },
    onKeyDown: () => { },
    autoFocus: false,
  };

  render() {
    const {
      classes,
      label,
      inputType,
      onChange,
      minLength,
      maxLength,
      required,
      invalidFeedback,
      fixedWidth,
      width,
      placeholder,
      name,
      style,
      labelStyle,
      value,
      multiline,
      dateType,
      autoComplete,
      resetButton,
      onFocus,
      onClick,
      onKeyDown,
      autoFocus,
    } = this.props;

    const props = placeholder ? { placeholder } : {};
    const croppedWidth = width ? { width } : {};

    return (
      <label className={classNames(classes.label, labelStyle)} htmlFor={`to${name}`}>
        {label || ' '}
        {dateType
          ? (
            <DatePicker
              id={`to${name}`}
              className={classNames('form-control', classes.input,
                fixedWidth ? classes.fixedWidth : classes.width)}
              selected={value || ''}
              dateFormat="EEEE, d MMM yyyy"
              onChange={val => onChange(val, name)}
            />
          )
          : multiline
            ? (
              <textarea
                id={`to${name}`}
                className={classNames('form-control', classes.input,
                  fixedWidth ? classes.fixedWidth : classes.width, style, classes.disableResize)}
                style={croppedWidth}
                value={this.props.value || ''}
                onChange={e => onChange(e.currentTarget.value, name)}
                rows={2}
              />
            )
            : (
              <div className={classes.inputContainer}>
                <input
                  {...props}
                  type={inputType}
                  className={classNames('form-control', classes.input,
                    fixedWidth ? classes.fixedWidth : classes.width, style)}
                  style={croppedWidth}
                  id={`to${name}`}
                  value={value || ''}
                  onChange={e => onChange(e.currentTarget.value, name)}
                  minLength={minLength}
                  maxLength={maxLength}
                  required={required}
                  autoComplete={autoComplete || 'new-password'}
                  autofill={'off'}
                  onFocus={onFocus}
                  onKeyDown={onKeyDown}
                  autoFocus={autoFocus}
                />
                { resetButton && (
                  <button
                    type="button"
                    className={classes.resetButton}
                    onClick={onClick}
                  >
                    <img alt="clear" src={clear} className={classes.resetButtonImage} />
                  </button>
                )}
              </div>
            )}
        <div className={'invalid-feedback'}>
          {invalidFeedback}
        </div>
      </label>
    );
  }
}

export default withStyles(styles)(Input);
